import { EventEmitter, ElementRef } from '@angular/core';
import { CommonService } from '../../common.service';
var CasePracticeStageStartComponent = (function () {
    function CasePracticeStageStartComponent(commonService, el) {
        this.commonService = commonService;
        this.el = el;
        this.onFinish = new EventEmitter();
        this.expression = false; //是否关闭判断
        this.endType = 0; //判断动画结束标识 0未执行 1执行
        this.assetsRoute = "../../../assets";
    }
    CasePracticeStageStartComponent.prototype.ngOnInit = function () {
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        this.setStageStartType(this.simulationName);
        this.setStageStartDocWithStep(this.step);
        // console.log(window.screen.width+';'+window.screen.height);
    };
    CasePracticeStageStartComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            'backgroundColor': 'transparent'
        });
        this.setEnableClick('.letterMiddle', this.endType);
    };
    // 设置阶段类型(P.S.目前只有2个情景模拟暂时写死)
    CasePracticeStageStartComponent.prototype.setStageStartType = function (simulationName) {
        if (simulationName == 'performance') {
            this.stageStartType = 1;
        }
        else {
            this.stageStartType = 0;
        }
    };
    //判断动画结束事件
    CasePracticeStageStartComponent.prototype.setEnableClick = function (dom, type) {
        var _this = this;
        this.expression = false;
        this.animateEndingElement = this.el.nativeElement.querySelector(dom);
        this.animateEndingElement.addEventListener('animationend', function () {
            if (type == 0) {
                _this.expression = true;
                console.log(type + ':animate is ending');
            }
            if (type == 1) {
                _this.onFinish.emit(true);
                _this.expression = false;
                console.log(type + ':animate is ending');
            }
        });
    };
    // 关闭动画
    CasePracticeStageStartComponent.prototype.closeAnimation = function () {
        if (this.expression) {
            this.endType = 1;
            $('.top-block').addClass('topImgClose');
            $('.bottom-block').addClass('bottomImgClose');
            this.setEnableClick('.bottomImgClose', this.endType);
        }
        else {
            return false;
        }
    };
    // 根据step设置内容
    CasePracticeStageStartComponent.prototype.setStageStartDocWithStep = function (step) {
        this.title = this.stageDocument['step' + step].title;
        this.tips = this.stageDocument['step' + step].stageContent;
        this.tipsContent = this.setTipsBottomLine(this.tips);
        this.stageImageSrc = this.stageDocument['step' + step].stageImage;
    };
    //设置文字下划线
    CasePracticeStageStartComponent.prototype.setTipsBottomLine = function (tips) {
        if (tips) {
            var html = '<p>';
            // console.log(tips.length);
            for (var i = 0, len = tips.length; i < len; i++) {
                html += tips[i];
                if (i > 0 && i % 16 == 0 && i < tips.length - 1) {
                    html += '</p><p>';
                }
                if (i == tips.length - 1) {
                    html += '</p>';
                }
            }
            return html;
        }
        else {
            return 'tips is undefined!';
        }
    };
    return CasePracticeStageStartComponent;
}());
export { CasePracticeStageStartComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-animation/case-practice-stage-start/case-practice-stage-start.component.ts.pre-build-optimizer.js